import type { LevelData } from '@/game/level';

export function cloneLevel(source: LevelData, sourceKind: 'builtin' | 'user', defaultAuthor: string): LevelData {
  const copy = JSON.parse(JSON.stringify(source)) as LevelData;
  const now = new Date().toISOString();
  const originalId = source.meta.id;
  copy.meta.id = crypto.randomUUID();
  copy.meta.name = `${source.meta.name} (Copy)`;
  copy.meta.author = defaultAuthor;
  copy.meta.source = { kind: sourceKind, sourceId: originalId };
  copy.meta.createdAt = now;
  copy.meta.updatedAt = now;
  return copy;
}
